import { Package } from 'lucide-react';

interface EmptyProductStateProps {
  title?: string;
  message?: string;
}

export default function EmptyProductState({
  title = 'No products found',
  message = 'Check back soon for our amazing selection!',
}: EmptyProductStateProps) {
  return (
    <div className="storefront-section-spacing">
      <div className="storefront-container">
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <div className="mb-4 p-4 rounded-full bg-neutral-100">
            <Package className="h-12 w-12 text-neutral-400" />
          </div>
          <h3 className="text-xl font-semibold text-neutral-900 mb-2">
            {title}
          </h3>
          <p className="text-neutral-600 max-w-md">{message}</p>
        </div>
      </div>
    </div>
  );
}
